import './index.styl';
import _ from 'lodash';
import template from './index.jst';
import { Model } from 'backbone';
import { View } from 'backbone.marionette';
import PlayerPoolList from '../PlayerPoolList'
import PlayerPoolFiltres from '../PlayerPoolFiltres'
import { AdvertisingView } from "../../../../../../core/views/widgets/Advertising";

const silent = { silent: true };

export class PlayerPool extends View {
	get template() {
		return template;
	}

	get className() {
		return 'player-pool-container';
	}

	ui() {
		return {
			toggle: '.js-player-pool-toggle-btn',
			list: '.js-player-pool-list',
			close: '.js-player-pool-close',
			close_mobile: '.js-player-pool-mobile-close',
			spacer: '.js-player-pool-spacer',
			legend: '.js-player-pool-stats-legend'
		}
	}

	events() {
		return {
			'click @ui.toggle': 'togglePlayerPool',
			'click @ui.close': 'togglePlayerPool',
		}
	}

	triggers() {
		return {
			'click @ui.close_mobile': 'toggle:player:pool'
		}
	}

	childViewEvents() {
		return {
			'filter:players': 'filterPlayersList',
			'player:add': 'onPlayerAdd',
			'filter:change:state': 'changePlayerListHeight'
		}
	}

	childViewTriggers() {
		return {
			'player:show:popup': 'player:show:popup'
		}
	}

	regions() {
		return {
			pool: '#player-pool-list',
			filters: '#player-pool-filters',
			ad: '.player-pool-ad-block'
		}
	}

	initialize() {
		this.model = new Model({
			selected_position: ''
		});

		this.getRegion('ad').show(new AdvertisingView({
			ad_id: 'player-pool-ad-slot-2',
			ad_path:'dfp-ad-slot-2',
			size: [300, 250],
			pos: 2,
		}));

		this.showChildView('pool', new PlayerPoolList());
		this.showChildView('filters', new PlayerPoolFiltres());
	}

	init(args) {
		this.model.set(args, silent);

		this.getChildView('filters').init(args);

		this.getChildView('pool').init({
			...args,
			selected_position: this.model.get('selected_position')
		});
	}

	switchPositionSelect(args) {
		let pos = args.pos,
			posInt = parseInt(pos, 10),
			position = posInt ? posInt : pos;

		this.model.set({
			selected_position: position
		}, silent);

		this.getChildView('filters').switchPositionSelect({
			...args,
			pos: position
		});

		if (this.model.get('is_mobile_view')) {
			this.getChildView('pool').init(this.model.toJSON());
		}
	}

	showPlayerPool() {
		this.ui.toggle.addClass('hidden');
		this.ui.list.removeClass('hidden');
	}

	togglePlayerPool() {
		let { list, toggle } = this.ui;

		if (list.hasClass('hidden')) {
			this.model.set({
				selected_position: ''
			}, silent);
		}

		$([list, toggle]).toggleClass('hidden');

		return this;
	}

	get order_by_options() {
		return [
			{ key: '', value: 'AVG' },
			{ key: 'cost', value: 'AVG' },
			{ key: 'name', value: 'AVG' },
			{ key: 'stats.avg_points', value: 'AVG' },
			{ key: 'stats.total_points', value: 'TOT' },
			{ key: 'stats.points_last_round', value: 'RD N' },
			{ key: 'stats.owned_by', value: 'TS%' },
			{ key: 'stats.cost_divided_by_points', value: '$/PTS' },
			{ key: 'stats.last_3_avg', value: 'L3 AVG' },
			{ key: 'stats.break_even', value: 'BE' },
			{ key: 'stats.proj_score', value: 'PROJ' }
		];
	}

	getHeaderTextByOrderSelect(filterRules) {
		let header_text = _.find(
			this.order_by_options,
			{ key: filterRules.order_by || '' }
		).value;

		if (header_text === 'RD N') {
			header_text = header_text.replace('N', this.model.get('last_round_id'));
		}

		return header_text;
	}

	filterPlayersList(filterRules) {
		this.ui.legend.text(
			this.getHeaderTextByOrderSelect(filterRules)
		);

		filterRules = _.omitBy(filterRules, _.negate(_.identity));

		//commented out to allow filtering more filters 
		// if (filterRules.filter_by_name) {
		// 	filterRules = _.pick(
		// 		filterRules,
		// 		['is_asc_order', 'order_by', 'filter_by_name']
		// 	);
		// }

		this.getChildView('pool').filterBy(filterRules);
	}

	onPlayerAdd({ model }) {
		const
			player = model.toJSON(),
			filter = this.getChildView('filters').model.get('selected');

		let position = parseInt(_.result(filter, 'filter_by_position', 0), 10);

		if (this.model.get('is_mobile_view')) {
			position = this.model.get('selected_position');
			this.ui.close_mobile.click();
		}

		this.trigger('player:add', { player, position });
	}

	onDomRefresh() {
		this.applyStyleWithCoachBanner();
	}

	applyStyleWithCoachBanner() {
		this.$el.toggleClass('with-coach-banner', this.model.get('is_show_banner'));

		return this;
	}

	setStyleWithCoachBanner(is_show_banner) {
		this.model.set({ is_show_banner }, silent);
		this.applyStyleWithCoachBanner();
	}

	changePlayerListHeight({ is_visible_filters }) {
		this.getRegion('pool').$el.toggleClass('with-filter', is_visible_filters);
	}
}

export default PlayerPool;